import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

interface TokenPayload {
  iat: number;
  exp: number;
  roles: string[];
  username: string;
  clientIdentifier: string;
}

const PrivateRoute: React.FC = () => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (token) {
    try {
      const decodedToken = jwtDecode<TokenPayload>(token);
      const roles = decodedToken.roles;

      if (!roles.includes("ROLE_ADMIN")) {
        return <Navigate to="/login" state={{ from: location }} replace />;
      }

      return <Outlet />;
    } catch (error) {
      console.error("Invalid token", error);
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivateRoute;
